// Payment-method paging shared by the SuperMarket payment bar and the Fashion
// payment panel. Moved verbatim out of useSuperMarketActions (showMoreItems /
// cyclePaymentMethodByKeyboard) so both layouts page the same eligible list.

const COMPLETE_ORDER_METHOD = {
  cWRPaymentMethodID: "",
  sequenceNo: 9999,
  finPaymentmethodId: "",
  finFinancialAccountId: "",
  finDayCloseAccountId: null,
  name: "Complete Order",
  integratedPayment: false,
  isloyalty: false,
  paymentProvider: null,
  iscredit: false,
  isGiftCard: false,
  isDefault: "N",
  csCurrencyId: "",
  isoCode: "AED",
  isactive: true,
  salesType: [],
};

// The eligible methods, plus the "Complete Order" pseudo-method for an advance
// order that has no advance-payment line yet.
export function pagedPaymentDetails({ getFilteredPaymentMethods, cart, posConfig }) {
  let paymentDetails = getFilteredPaymentMethods();
  if (
    cart?.docType === "Advance" &&
    posConfig?.allowLayawaywithoutPayment !== "Y" &&
    !cart.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
  ) {
    paymentDetails = [...paymentDetails, ...(posConfig?.enablePreOrder !== "Y" ? [{ ...COMPLETE_ORDER_METHOD, salesType: [] }] : [])];
  }
  return paymentDetails;
}

export function paymentItemsPerPage({ tillData, cart }) {
  const PaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
  return tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5
    ? 5
    : cart.layAway === "Y" || cart?.creditSale === "Y"
      ? 4
      : 5;
}

// The "..." button: next screenful, wrapping back to the first.
export function showNextPaymentPage({ getFilteredPaymentMethods, cart, posConfig, tillData, startIndex, setShowPayments, setStartIndex }) {
  const paymentDetails = pagedPaymentDetails({ getFilteredPaymentMethods, cart, posConfig });
  const itemsPerPage = paymentItemsPerPage({ tillData, cart });
  if (paymentDetails.length <= itemsPerPage) {
    setShowPayments(paymentDetails);
    setStartIndex(paymentDetails.length);
  } else if (startIndex >= paymentDetails.length) {
    setShowPayments(paymentDetails.slice(0, itemsPerPage));
    setStartIndex(itemsPerPage);
  } else if (startIndex + itemsPerPage >= paymentDetails.length) {
    setShowPayments(paymentDetails.slice(startIndex, paymentDetails.length));
    setStartIndex(paymentDetails.length);
  } else {
    setShowPayments(paymentDetails.slice(startIndex, itemsPerPage + startIndex));
    setStartIndex(startIndex + itemsPerPage);
  }
}

// Back to the first screenful. SMPaymentBar only offers "previous" while
// isShowingAll is true, which nothing sets today, so this is reached only if
// that changes; it replaces the empty showPreviousItems the bars passed before.
export function showFirstPaymentPage({ getFilteredPaymentMethods, cart, posConfig, tillData, setShowPayments, setStartIndex }) {
  const paymentDetails = pagedPaymentDetails({ getFilteredPaymentMethods, cart, posConfig });
  const itemsPerPage = paymentItemsPerPage({ tillData, cart });
  const firstPage = paymentDetails.slice(0, itemsPerPage);
  setShowPayments(firstPage);
  setStartIndex(firstPage.length);
}

// Left/Right arrow cycling across the full eligible list; shows the page that
// holds the chosen method and selects it.
export function cyclePaymentMethod(
  { getFilteredPaymentMethods, cart, posConfig, tillData, setShowPayments, setStartIndex, setSelectedPaymentMethod },
  currentMethodId,
  direction
) {
  const paymentDetails = pagedPaymentDetails({ getFilteredPaymentMethods, cart, posConfig });
  if (paymentDetails.length === 0) return null;
  const itemsPerPage = paymentItemsPerPage({ tillData, cart });

  const currentIndex = paymentDetails.findIndex((pm) => pm.finPaymentmethodId === currentMethodId);
  let nextIndex;
  if (currentIndex === -1) {
    nextIndex = direction === "next" ? 0 : paymentDetails.length - 1;
  } else if (direction === "next") {
    nextIndex = (currentIndex + 1) % paymentDetails.length;
  } else {
    nextIndex = (currentIndex - 1 + paymentDetails.length) % paymentDetails.length;
  }

  const windowStart = Math.floor(nextIndex / itemsPerPage) * itemsPerPage;
  const windowEnd = Math.min(windowStart + itemsPerPage, paymentDetails.length);
  setShowPayments(paymentDetails.slice(windowStart, windowEnd));
  setStartIndex(windowEnd);

  const nextMethod = paymentDetails[nextIndex];
  setSelectedPaymentMethod(nextMethod);
  return nextMethod;
}

export const modulo = (a, b) => a - b * Math.floor(a / b);
